/**
 * @generated SignedSource<<efa1f88067643cd9e7d1169728e1ed87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageSettingsDeleteButton_image$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PageSettingsSmallImage_image">;
  readonly " $fragmentType": "PageSettingsDeleteButton_image";
};
export type PageSettingsDeleteButton_image$key = {
  readonly " $data"?: PageSettingsDeleteButton_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageSettingsDeleteButton_image">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSettingsDeleteButton_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSettingsSmallImage_image"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "e977358e4caba0c918cb0ca2daa4cb51";

export default node;
